import { render } from "./ModalContentInfo.vue?vue&type=template&id=278f1cc3&scoped=true"
import script from "./ModalContentInfo.vue?vue&type=script&lang=js"
export * from "./ModalContentInfo.vue?vue&type=script&lang=js"

import "./ModalContentInfo.vue?vue&type=style&index=0&id=278f1cc3&scoped=true&lang=css"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-278f1cc3"]])

export default __exports__